import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { TabberButton } from "../../../../common/custom-form/tabber-button.component";
import '../invoice-upload.component.css';
import CustomSearchableSelectWrapper from "../../../../common/custom-form/custom-searchable-select-wrapper.component";
import { EXTRACT_TEMPLATE_MODULES, FILE_NAME_TEMPLATE, INVOICE_HANDLER, MAX_LENGTH, MODAL_CUSTOM_MESSAGE, MODAL_CUSTOM_TITLE, UPLOAD_TYPES } from "../../../../../constants/external-constants";
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import { invoiceUploadAction } from '../../../../../store/external/invoice/invoice-upload/invoice-upload.reducer';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import store from '../../../../../store';
import MobilityAll from "../invoice-upload-field/mobility-all.component";
import TMobile from "../invoice-upload-field/t-mobile.component";
import VerizonWireless from "../invoice-upload-field/verizon-wireless.component";
import DragDropUpload from "../../../../common/upload/drag-drop-upload/drag-drop-upload.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { Loading } from "../../../../common/loading";
import { convertToFormatDate } from "../../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../../utils/helpers.utils";


class InvoiceUploader extends Component {
    constructor(props) {
        super(props);
        this.childRef = React.createRef();
        this.state = {
            uploadedFiles:[],
            allowedFiles:[], 
            maxFiles:0,
            showNotif: false,
            isLoading:true,
            filterLoading:false,
            loadingLabel: "",
            uploadInProgress: false
        }
    }

   async componentDidMount(){     
        const {getVendorDetails, resetUploadForm}=this.props; 
        store.dispatch(actions.reset('invoiceUploadForm.vendorId')); 
        store.dispatch(actions.reset('invoiceUploadForm.invoiceMasterId'));   
        await  resetUploadForm(); 
        await getVendorDetails().then(()=>{ this.setState({isLoading:false})
        });
      }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    disabledUpload = () => {
        const { invoiceUploadForm } = this.props;
        const intialField = !(!invoiceUploadForm.vendorId && !invoiceUploadForm.invoiceMasterId && !invoiceUploadForm.financeAccountId);
        let additionalField = true;

        if(invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.verizonwireless || invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.tmobile) {
            additionalField = invoiceUploadForm.invoiceNumber !== "" && invoiceUploadForm.invoiceDate !== null
        } else if(invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.attmobility2 || invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.attmobilityall) {
            additionalField = invoiceUploadForm.invoiceNumber !== "" && invoiceUploadForm.invoiceDate !== null && invoiceUploadForm.fanChargesAndCredits !== ""
        }
        else if (invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.verizonwireless2) {
            additionalField = invoiceUploadForm.invoiceDate !== null
        }

        let validFiles = false;
        if (this.childRef.current) {
            validFiles = this.childRef.current.checkValidFileForm();
        }
        
        return !(intialField && additionalField && validFiles);
    }
    
    dropDragDisable = () => {
        const { invoiceUploadForm } = this.props;
        const intialField = invoiceUploadForm.vendorId && invoiceUploadForm.invoiceMasterId && invoiceUploadForm.financeAccountId
        let additionalField=true;

        if(invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.verizonwireless || invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.tmobile) {
            additionalField = invoiceUploadForm.invoiceNumber !== "" && invoiceUploadForm.invoiceDate !== null
        } else if(invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.attmobility2 || invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.attmobilityall) {
            additionalField = invoiceUploadForm.invoiceNumber !== "" && invoiceUploadForm.invoiceDate !== null && invoiceUploadForm.fanChargesAndCredits !== ""
        } else if (invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.verizonwireless2) {
            additionalField = invoiceUploadForm.invoiceDate !== null
        }
        return !(intialField && additionalField );
    }
    
    onChangeVendor = async (id) => {
        const { getBillingAccount, getInvoiceMaster } = this.props;
        store.dispatch(actions.change('invoiceUploadForm.vendorId', id));
        this.setState({
            filterLoading: true
        })
        await getInvoiceMaster(id)
        await getBillingAccount().then(() => {
            this.setState({ filterLoading: false })
        });
    }
    
    onChangeInvoiceMaster = async (id) => {
        const { invoiceMasteroptions } = this.props.invoiceUpload;
        const { resetUploadForm, getInvoiceMasterConfig } = this.props;
        resetUploadForm();

        if (this.childRef.current) {
            this.childRef.current.removeFiles();
        }

        const { InvoiceGuid } = invoiceMasteroptions.find(i => i.InvoiceMasterId == id);
        this.setState({
            filterLoading: true
        });
        await getInvoiceMasterConfig(InvoiceGuid);
        store.dispatch(actions.change('invoiceUploadForm.invoiceMasterId', id));
        this.setState({ filterLoading: false });
    }

    onChangeBillingAccount = (id) => {
        store.dispatch(actions.change('invoiceUploadForm.financeAccountId', id));   
    }

    SelectDate =(date)=>{       
        store.dispatch(actions.change('invoiceUploadForm.invoiceDate', date));
    }

    Toggle =(value)=>{
        store.dispatch(actions.change('invoiceUploadForm.creditNote', value));
    }

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    }

    handleUpload = ()=>{
        if (this.childRef.current) {
            this.childRef.current.processQueue();
        }
        this.setState({
            uploadInProgress: true
        });
    }

    handleDrop = () => {
        this.setState({
            isFileDropped: true,
        });
    };

    handleAddFiles = () => {
        this.forceUpdate();
    }

    handleRemoveFiles = () => {
        this.forceUpdate();
    }

    handleSuccessProcess = (data) => {
        const { postExecuteHandlerProcess } = this.props;
        postExecuteHandlerProcess(data.BatchId);
        this.setState({
            uploadInProgress: false
        });
    }

    djsConfigParams = () => {
        const { invoiceUploadForm } = this.props;
        const { invoiceMasteroptions, vendorOptions, invoiceMasterConfig } = this.props.invoiceUpload;

        var invoiceDate = new Date(invoiceUploadForm.invoiceDate);

        var baseParams = {
            DealName: sessionStorage.getItem('DealName'),
            InvoiceGuid: invoiceMasteroptions?.find(i => i.InvoiceMasterId == invoiceUploadForm.invoiceMasterId)?.InvoiceGuid,
            VendorDetailId: invoiceUploadForm.vendorId,
            FinanceAccountId: invoiceUploadForm.financeAccountId,
            VendorName: vendorOptions?.find(i => i.Key == invoiceUploadForm.vendorId)?.Value.replace('[Preferred]', '').trim(),
            IsCreditNote: invoiceUploadForm.creditNote
        };

        const pInvoiceDate = invoiceDate.toString() != 'Invalid Date' ? convertToFormatDate(invoiceDate, 'YYYY-MM-DD') : '';

        if (invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.attmobility2) {
            baseParams = {
                ...baseParams,
                InvoiceDate: pInvoiceDate,
                InvoiceNumber: invoiceUploadForm.invoiceNumber,
                AdjusmentCreditAmount: invoiceUploadForm.fanChargesAndCredits
            };
        }
        else if (invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.attmobilityall) {
            baseParams = {
                ...baseParams,
                InvoiceDate: pInvoiceDate,
                InvoiceNumber: invoiceUploadForm.invoiceNumber,
                FANChargesAndCredits: invoiceUploadForm.fanChargesAndCredits
            };
        }
        else if (invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.verizonwireless || invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.tmobile) {
            baseParams = {
                ...baseParams,
                InvoiceDate: pInvoiceDate,
                InvoiceNumber: invoiceUploadForm.invoiceNumber
            };
        }
        else if (invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.generichandler) {
            baseParams = {
                ...baseParams,
            };
        }
        else if (invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.verizonwireless2) {
            baseParams = {
                ...baseParams,
                InvoiceDate: pInvoiceDate
            };
        }

        var djsConfig = {
            params: {
                ...baseParams,
                UploadTypeId: UPLOAD_TYPES.InvoiceUpload,
                CustomData: JSON.stringify({
                    ...baseParams,
                }), 
                CreatedBy: sessionStorage.getItem('EID').toString(),
                UserId: sessionStorage.getItem('UserID').toString(),
            },
            maxFiles: invoiceMasterConfig.MaxTotal,
            minFiles: invoiceMasterConfig.MinTotal,
            acceptedFiles: invoiceMasterConfig.AcceptedFileTypes,
            dictInvalidFileType: this.toLocaleLanguage('error_invalid_file_type'),
            dictMaxFilesExceeded: this.toLocaleLanguage('error_exceeded_maximum_file'),
            dictErrorOccured: this.toLocaleLanguage('error_occured_reupload_file')
        };

        return djsConfig;
    }

    handleDownloadTemplate = () =>{
        const {downloadGenericTemplate} = this.props;
        this.setState({
            filterLoading:true,
            loadingLabel:"Downloading"
        })
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            downloadGenericTemplate(EXTRACT_TEMPLATE_MODULES.genericTemplate,FILE_NAME_TEMPLATE.genericTempalte).then(()=>{ this.setState({filterLoading:false,
            loadingLabel:""})
        });;
        }  else {
            this.setState({filterLoading:false,
                loadingLabel:""})
        }     
    }

    onErrorUpload = () =>{
        this.setState({
            uploadInProgress: false
        })
    }

    render() {
      
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceInvoiceUploadDashboardRW])
        const { invoiceUploadForm } = this.props;
        const { vendorOptions, invoiceMasteroptions, billingAccount } = this.props.invoiceUpload;
        if(this.state.isLoading) {
            return <Loading />
        }
		return (
			<div className="invoice-upload">
                {
                    this.state.filterLoading &&
                    <Loading customClass="filter-loading" label={this.state.loadingLabel}/>	
                }
                
				<div className="invoice-cont-wrapper">
						<div className="items-container">
							<div className="items-list">
                                <CustomSearchableSelectWrapper
                                    label={`${this.toLocaleLanguage('vendor')}`}
                                    options={vendorOptions}
                                    selected={invoiceUploadForm.vendorId}
                                    onChange={(e) => this.onChangeVendor(e)}
                                    requiredField
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    fieldProp='invoiceUploadForm.vendorId'
                                    tagName='vendorDetailId'
                                    maxLength={MAX_LENGTH.limit_255}
                                    optionLabelKey={{
                                            Key: 'Key',
                                            Value: 'Value'
                                    }}  
                                
                                />


                                <CustomSearchableSelectWrapper
                                    label={`${this.toLocaleLanguage('invoice_handler')}`}
                                    options={invoiceMasteroptions}
                                    selected={invoiceUploadForm.invoiceMasterId}
                                    onChange={(e) => this.onChangeInvoiceMaster(e)}
                                    requiredField
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    fieldProp='invoiceUploadForm.invoiceMasterId'
                                    tagName='invoiceMasterId'
                                    maxLength={MAX_LENGTH.limit_255}
                                    optionLabelKey={{
                                        Key: 'InvoiceMasterId',
                                        Value: 'InvoiceMasterName'
                                    }} 
                                />
								
							    <CustomSearchableSelectWrapper
                                    label={`${this.toLocaleLanguage('billing_account_num')}`}
                                    options={billingAccount}
                                    selected={invoiceUploadForm.financeAccountId}
                                    onChange={(e) => this.onChangeBillingAccount(e)}
                                    requiredField
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    fieldProp='invoiceUploadForm.financeAccountId'
                                    tagName='billingAccountID'
                                    maxLength={MAX_LENGTH.limit_255}
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                        }}
                                
                                />

                                {
                                    invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.verizonwireless ?
                                       <VerizonWireless
                                        Datelabel={`${this.toLocaleLanguage('invoice_date')}`}
                                        InvoiceLabel={`${this.toLocaleLanguage('invoice_number')}`}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        selectedDate={this.SelectDate}
                                        startDate={invoiceUploadForm.invoiceDate}

                                        invoiceNumber={invoiceUploadForm.invoiceNumber}
                                        placeholderInvoiceNumber={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                        hiddenInvoiceNumber={false}
                                       />
                                    :
                                    invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.verizonwireless2 ?
                                        <VerizonWireless
                                            Datelabel={`${this.toLocaleLanguage('invoice_date')}`}
                                            placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                            selectedDate={this.SelectDate}
                                            startDate={invoiceUploadForm.invoiceDate}

                                            hiddenInvoiceNumber={true}
                                        />
                                        :
                                    invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.attmobility2 ?
                                         <MobilityAll
                                            Datelabel={`${this.toLocaleLanguage('invoice_date')}`}
                                            InvoiceLabel={`${this.toLocaleLanguage('invoice_number')}`}
                                            CreditLabel={`${this.toLocaleLanguage('adjustment_credit_amount')}`}
                                            placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                            selectedDate={this.SelectDate}
                                            startDate={invoiceUploadForm.invoiceDate}

                                            invoiceNumber={invoiceUploadForm.invoiceNumber}
                                            placeholderInvoiceNumber={`${this.toLocaleLanguage('enter_text_placeholder')}`}

                                            invoiceUploadForm={invoiceUploadForm.fanChargesAndCredits}
                                         />
                                    :
                                    invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.tmobile ?
                                        <TMobile 
                                            Datelabel={`${this.toLocaleLanguage('invoice_date')}`}
                                            InvoiceLabel={`${this.toLocaleLanguage('invoice_number')}`}
                                            placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                            selectedDate={this.SelectDate}
                                            startDate={invoiceUploadForm.invoiceDate}

                                            invoiceNumber={invoiceUploadForm.invoiceNumber}
                                            placeholderInvoiceNumber={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                        />
                                    :
                                    invoiceUploadForm.invoiceMasterId === INVOICE_HANDLER.attmobilityall ?
                                        <MobilityAll
                                            Datelabel={`${this.toLocaleLanguage('invoice_date')}`}
                                            InvoiceLabel={`${this.toLocaleLanguage('invoice_number')}`}
                                            CreditLabel={`${this.toLocaleLanguage('fan_charges_credits')}`}
                                            placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                            selectedDate={this.SelectDate}
                                            startDate={invoiceUploadForm.invoiceDate}

                                            invoiceNumber={invoiceUploadForm.invoiceNumber}
                                            placeholderInvoiceNumber={`${this.toLocaleLanguage('enter_text_placeholder')}`}

                                            invoiceUploadForm={invoiceUploadForm.fanChargesAndCredits}
                                        />
                                    :
                                    null
                                }
								
								<TabberButton label="Credit Note" onToggle={this.Toggle}/>
							</div>
							
                            <DragDropUpload 
                                ref={this.childRef}
                                buttonLabel={"Download Generic Template"}
                                disabled={this.dropDragDisable() || this.state.uploadInProgress}
                                downloadButton={this.handleDownloadTemplate}
                                djsConfigParams={this.djsConfigParams()}
                                onSuccessProcess={this.handleSuccessProcess}
                                onAddFiles={this.handleAddFiles}
                                onRemoveFiles={this.handleRemoveFiles}
                                onErrorUpload={this.onErrorUpload}
                                uploadTypeId={UPLOAD_TYPES.InvoiceUpload}
                            />
                    </div>
                    {isReadAndWrite ?
                        <Button className="upload-button" disabled={this.disabledUpload() || this.state.uploadInProgress} onClick={this.handleUpload}>Upload</Button>
                        : null}
                </div>
                <NotificationModal
                    show={this.state.showNotif}
                    title={MODAL_CUSTOM_TITLE.Notification}
                    message={MODAL_CUSTOM_MESSAGE.upload_notification}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />              
                </div>
		)
	}
}


export default connect(
    state=>{
        const {
            invoiceUpload,
            translation
        }=state;

        const { invoiceUploadForm } = state.form;
    
        return {
            invoiceUpload,
            invoiceUploadForm,
            translation
        }
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceUploadAction),
        dispatch
    )  

)(InvoiceUploader);
